// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31pRT","index":"styles_index__39VrJ"};